import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { AngularSplitModule } from 'angular-split';
import { NgApexchartsModule } from 'ng-apexcharts';
import {
  AsyncFormFieldValidateDirective,
  EditTableComponent,
  FormFieldValidateDirective,
  FormValidationDirective,
  NumericEditorComponent,
  PrettyJsonPipe,
  SearchableSelectComponent,
  SelectJobFormFieldComponent,
  TableComponent,
  TimeUnitsPipe,
  ValidationErrorsComponent,
  WizardBarComponent,
  WizardComponent,
  WizardStepDirective,
} from '.';
import { CellMatDatePickerComponent } from './ag-grid/cell-mat-date-picker';
import { CheckboxCellRendererComponent } from './ag-grid/checkbox-cell-renderer.component';
import { CheckboxMenuHeaderComponent } from './ag-grid/checkbox-menu-header.component';
import { GroupLinkRendererComponent } from './ag-grid/group-link-renderer.component';
import { IconCellRendererComponent } from './ag-grid/icon-cell-renderer.component';
import {
  FlatButtonComponent,
  OutlineBackButtonComponent,
  OutlineButtonComponent,
  RaisedButtonComponent,
} from './button';
import {
  BusyDirective,
  DisableWhileBusyDirective,
  HasAllRolesDirective,
  HasRoleDirective,
  MatTooltipOnTruncatedDirective,
  NotBusyDirective,
  PermissionsDirective,
} from './directives';
import { PageBoxComponent } from './format/page-box.component';
import { PageHeaderComponent } from './format/page-header.component';
import { IntlDateAdapter } from './intl-date-adapter';
import { MessageBoxComponent, TextEditDialogComponent } from './messagebox';
import { DateRangeDialogComponent } from './messagebox/date-range-dialog.component';
import { InsolCurrencyPipe } from './pipes/insolcurrency.pipe';
import { SelectJobTypeFormFieldComponent } from './controls/select-job-type-form-field.component';

export const sharedModules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  MatTableModule,
  MatDatepickerModule,
  MatIconModule,
  MatTooltipModule,
  MatCheckboxModule,
  MatDialogModule,
  MatButtonModule,
  MatFormFieldModule,
  MatInputModule,
  MatTabsModule,
  MatSelectModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatPaginatorModule,
  MatExpansionModule,
  MatListModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatMenuModule,
  MatRadioModule,
  MatSnackBarModule,
  NgApexchartsModule,
  AngularSplitModule,
  FuseDrawerComponent,
  FuseCardComponent,
];

export const declarables = [
  PrettyJsonPipe,
  InsolCurrencyPipe,
  EditTableComponent,
  TableComponent,
  FlatButtonComponent,
  RaisedButtonComponent,
  OutlineButtonComponent,
  OutlineBackButtonComponent,
  BusyDirective,
  NotBusyDirective,
  MatTooltipOnTruncatedDirective,
  MessageBoxComponent,
  HasRoleDirective,
  HasAllRolesDirective,
  PermissionsDirective,
  DisableWhileBusyDirective,
  ValidationErrorsComponent,
  FormFieldValidateDirective,
  AsyncFormFieldValidateDirective,
  FormValidationDirective,
  PageHeaderComponent,
  PageBoxComponent,
  CellMatDatePickerComponent,
  GroupLinkRendererComponent,
  IconCellRendererComponent,
  CheckboxCellRendererComponent,
  CheckboxMenuHeaderComponent,
  NumericEditorComponent,
  TextEditDialogComponent,
  DateRangeDialogComponent,
  SelectJobFormFieldComponent,
  SelectJobTypeFormFieldComponent,
  WizardStepDirective,
  WizardComponent,
  WizardBarComponent,
  TimeUnitsPipe,
  SearchableSelectComponent,
];

@NgModule({
  imports: [...sharedModules, MatNativeDateModule],
  declarations: declarables,
  exports: [...sharedModules, ...declarables],
  providers: [MatNativeDateModule, { provide: DateAdapter, useClass: IntlDateAdapter }],
})
export class SharedModule {}
